import { Injectable } from '@angular/core';
import { IAltHesap, ICariHesapEkstresi, IDaireBorcAlacak, IDigerBorcAlacak, IGelirGider, IIcraBorcAlacak, ITedarikciBorcAlacak } from '@models/finance';
import { IListMenu } from '@shared/models/interfaces';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FinanceService {

  constructor() { }

  getGelirGider$(): Observable<IGelirGider[]> {
    return of(gelirGider);
  }

  getDigerBorcAlacak$(): Observable<IDigerBorcAlacak[]> {
    return of(digerBorcAlacak);
  }

  getTedarikciBorcAlacak$(): Observable<ITedarikciBorcAlacak[]> {
    return of(tedarikciBorcAlacak);
  }

  getIcraBorcAlacak$(): Observable<IIcraBorcAlacak[]> {
    return of(icraBorcAlacak);
  }

  getAltHesaplar$(): Observable<IAltHesap[]> {
    return of(altHesaplar);
  }

  getCariHesapEkstresi$(): Observable<ICariHesapEkstresi[]> {
    return of(cariHesapEkstresi);
  }

  getDaireBorcAlacak$(): Observable<IDaireBorcAlacak[]> {
    return of(daireBorcAlacak);
  }

  getFinanceMenu$(): Observable<IListMenu[]> {
    return of(financeMenu);
  }
}

const gelirGider: IGelirGider[] = [{
  gelirID: 1, durumID: 1, tarih: new Date('2021-05-01T02:14:13'), masrafKalemKodu: '600.001', masrafKalemAdi: 'Elektrik Giderleri', bakiye: 2113
}, {
  gelirID: 2, durumID: -1, tarih: new Date('2021-05-05T02:14:13'), masrafKalemKodu: '700.008', masrafKalemAdi: 'Yönetim Giderleri', bakiye: 1572
}, {
  gelirID: 3, durumID: 1, tarih: new Date('2021-05-01T02:14:13'), masrafKalemKodu: '600.005', masrafKalemAdi: 'Gecikme Tazminatı Gelirleri', bakiye: 113
},{
  gelirID: 4, durumID: 1, tarih: new Date('2021-05-03T02:14:13'), masrafKalemKodu: '600.006', masrafKalemAdi: 'Kira ve Bağış Gelirleri', bakiye: 4
}];

const digerBorcAlacak: IDigerBorcAlacak[] = [{
  digerBorcID: 1, hesapID: 11, hesapAdi: 'TTNET İnternet', firmaUnvani: 'Türk Telekom', bakiye: 8340, bakiyeDurumu: 'A'
}, {
  digerBorcID: 2, hesapID: 21, hesapAdi: 'Doğalgaz', firmaUnvani: 'Kargaz', bakiye: 3200, bakiyeDurumu: 'B'
}, {
  digerBorcID: 3, hesapID: 31, hesapAdi: 'Avrupa Konutları', firmaUnvani: 'Avrupa Konutları A.Ş.', bakiye: 370, bakiyeDurumu: 'A'
},{
  digerBorcID: 4, hesapID: 41, hesapAdi: 'Yurtiçi Kargo', firmaUnvani: 'Yurtiçi Kargo Firma LTD. A.Ş.', bakiye: 8, bakiyeDurumu: 'B'
}];

const tedarikciBorcAlacak: ITedarikciBorcAlacak[] = [{
  tedarikciID: 1, hesapID: 11, hesapAdi: 'Boğaziçi Elektrik', firmaUnvani: 'CLK Boğaziçi', bakiye: 8340, bakiyeDurumu: 'A'
}, {
  tedarikciID: 2, hesapID: 21, hesapAdi: 'Doğalgaz', firmaUnvani: 'İğdaş', bakiye: 3200, bakiyeDurumu: 'B'
}, {
  tedarikciID: 3, hesapID: 31, hesapAdi: 'OTİS Asansör', firmaUnvani: 'Otis A.Ş.', bakiye: 370, bakiyeDurumu: 'A'
},{
  tedarikciID: 4, hesapID: 41, hesapAdi: 'Aras Kargo', firmaUnvani: 'Aras Kargo Firma LTD. A.Ş.', bakiye: 8, bakiyeDurumu: 'B'
}];

const icraBorcAlacak: IIcraBorcAlacak[] = [{
  icraID: 9312, hesapID: 1, hesapAdi: 'Hasan Ali', blokID: 11, blokNo: '23', bolumID: 111, bolumNo: '01',
  bakiye: 1000, bakiyeDurumu: 'B'
}, {
  icraID: 5942, hesapID: 2, hesapAdi: 'Hasan Can', blokID: 21, blokNo: '41', bolumID: 211, bolumNo: '31',
  bakiye: 1300, bakiyeDurumu: '',
}, {
  icraID: 4123, hesapID: 3, hesapAdi: 'Hasan Cem', blokID: 31, blokNo: '18', bolumID: 311, bolumNo: '15',
  bakiye: 100, bakiyeDurumu: 'A'
}, {
  icraID: 4557, hesapID: 4, hesapAdi: 'Hasan Veli', blokID: 41, blokNo: '03', bolumID: 411, bolumNo: '24',
  bakiye: 300, bakiyeDurumu: ''
}];

const cariHesapEkstresi: ICariHesapEkstresi[] = [{
  cariID: 1, tarih: new Date('2021-04-29T02:14:13'), vade: new Date('2021-04-29T02:14:13'), borc: 2000, alacak: 3200, bakiye: 1400, bakiyeDurumu: 'B', hareketTuru: 'Devir', aciklama: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vel dui ut arcu dignissim varius. Cras viverra bibendum magna, non imperdiet tortor hendrerit vel. Vivamus id est lorem. Aliquam auctor neque non vestibulum posuere. Suspendisse at eros sagittis, vestibulum elit eget, fermentum elit. Pellentesque dolor dolor, tempor in euismod et, consequat ut justo. Curabitur cursus lorem dolor, et convallis arcu convallis sit amet.'
}, {
  cariID: 2, tarih: new Date('2021-04-27T02:14:13'), vade: new Date('2021-04-27T02:14:13'), borc: 0, alacak: 1640, bakiye: 1350, bakiyeDurumu: 'A', hareketTuru: 'Borç Tahakkuku', aciklama: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vel dui ut arcu dignissim varius. Cras viverra bibendum magna, non imperdiet tortor hendrerit vel. Vivamus id est lorem. Aliquam auctor neque non vestibulum posuere. Suspendisse at eros sagittis, vestibulum elit eget, fermentum elit. Pellentesque dolor dolor, tempor in euismod et, consequat ut justo. Curabitur cursus lorem dolor, et convallis arcu convallis sit amet.'
}, {
  cariID: 3, tarih: new Date('2021-04-24T02:14:13'), vade: new Date('2021-04-24T02:14:13'), borc: 500, alacak: 1200, bakiye: 1350, bakiyeDurumu: 'B', hareketTuru: 'Kredi Kartı', aciklama: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vel dui ut arcu dignissim varius. Cras viverra bibendum magna, non imperdiet tortor hendrerit vel. Vivamus id est lorem. Aliquam auctor neque non vestibulum posuere. Suspendisse at eros sagittis, vestibulum elit eget, fermentum elit. Pellentesque dolor dolor, tempor in euismod et, consequat ut justo. Curabitur cursus lorem dolor, et convallis arcu convallis sit amet.'
}, {
  cariID: 4, tarih: new Date('2021-04-21T02:14:13'), vade: new Date('2021-04-21T02:14:13'), borc: 0, alacak: 1000, bakiye: 234350, bakiyeDurumu: 'A', hareketTuru: 'Devir', aciklama: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vel dui ut arcu dignissim varius. Cras viverra bibendum magna, non imperdiet tortor hendrerit vel. Vivamus id est lorem. Aliquam auctor neque non vestibulum posuere. Suspendisse at eros sagittis, vestibulum elit eget, fermentum elit. Pellentesque dolor dolor, tempor in euismod et, consequat ut justo. Curabitur cursus lorem dolor, et convallis arcu convallis sit amet.'
}];

const altHesaplar: IAltHesap[] = [{
  altHesapTurID: 1, altHesapTuru: 'FinanceModule.Payment.Dues', kalan: 80, tutar: 0
}, {
  altHesapTurID: 2, altHesapTuru: 'FinanceModule.Payment.DelayPenalty', kalan: 45, tutar: 0
}, {
  altHesapTurID: 3, altHesapTuru: 'FinanceModule.Payment.Water', kalan: 120, tutar: 0
}, {
  altHesapTurID: 4, altHesapTuru: 'FinanceModule.Payment.Electricity', kalan: 180, tutar: 0
}, {
  altHesapTurID: 5, altHesapTuru: 'FinanceModule.Payment.CardAndOgsSalesExpenses', kalan: 0, tutar: 0
}, {
  altHesapTurID: 6, altHesapTuru: 'FinanceModule.Payment.OtherExpenses', kalan: 400, tutar: 0
}];

const daireBorcAlacak: IDaireBorcAlacak[] = [{
  hesapID: 1, hesapAdi: 'Hasan Ali', blokID: 11, blokNo: '23', bolumID: 111, bolumNo: '01',
  bakiye: 1000, bakiyeDurumu: 'B', mulkiyetDurumu: 'Kiracı', eposta: 'hasan.ali@gmail.com', telefon: '544 453 3343',
}, {
  hesapID: 2, hesapAdi: 'Hasan Can', blokID: 21, blokNo: '41', bolumID: 211, bolumNo: '31',
  bakiye: 1300, bakiyeDurumu: '', mulkiyetDurumu: 'Mülk Sahibi', eposta: 'hasan.can@gmail.com', telefon: '433 334 3321',
}, {
  hesapID: 3, hesapAdi: 'Hasan Cem', blokID: 31, blokNo: '18', bolumID: 311, bolumNo: '15',
  bakiye: 100, bakiyeDurumu: 'A', mulkiyetDurumu: 'Kiracı', eposta: 'hasan.cem@gmail.com', telefon: '555 432 2211',
}, {
  hesapID: 4, hesapAdi: 'Hasan Veli', blokID: 41, blokNo: '03', bolumID: 411, bolumNo: '24',
  bakiye: 300, bakiyeDurumu: '', mulkiyetDurumu: 'Kiracı', eposta: 'hasan.veli@gmail.com', telefon: '532 211 4312',
}];

const financeMenu: IListMenu[] = [{
  menuID: 1, menuUrl: 'app/finance/daire-borc-alacak', menuName: 'FinanceModule.ApartmentDebt.Title', menuColor: 'cyan', menuIcon: 'apartment-debt'
}, {
  menuID: 2, menuUrl: 'app/finance/icra-borc-alacak', menuName: 'FinanceModule.ExecutiveDebt.Title', menuColor: 'success', menuIcon: 'executive-debt'
}, {
  menuID: 3, menuUrl: 'app/finance/tedarikci-borc-alacak', menuName: 'FinanceModule.SupplierDebt.Title', menuColor: 'danger', menuIcon: 'supplier-debts'
}, {
  menuID: 4, menuUrl: 'app/finance/diger-borc-alacak', menuName: 'FinanceModule.OtherDebt.Title', menuColor: 'warning', menuIcon: 'other-debts'
}, {
  menuID: 5, menuUrl: 'app/finance/gelir-gider', menuName: 'FinanceModule.IncomeExpense.Title', menuColor: 'orange', menuIcon: 'income-expense'
}];
